import { TextBoxOutlineIcon } from './TextBoxOutlineIcon';

/**
 * author: GreenTurtwig
 * id E12AE178-0546-4CD3-81F6-BD1F17AA50EE
 * name text-box-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text-box-outline.svg
 * tags
 * - Files / Folders 
 */
export const FileDocumentBoxOutlineIcon = TextBoxOutlineIcon;
export default FileDocumentBoxOutlineIcon